import { cva } from 'class-variance-authority';
import type { PillColorsEnum } from '../types';

const labelVariants = cva('flex', {
  variants: {
    variant: {
      soft: '',
      clear: '',
      solid: 'text-white',
    },
    color: {
      gray: '',
      brand: '',
      error: '',
      warning: '',
      success: '',
      blue: '',
      purple: '',
      fuchsia: '',
      cyan: '',
      lime: '',
      pink: '',
      violet: '',
      indigo: '',
      rose: '',
      yellow: '',
    } satisfies Record<PillColorsEnum, string>,
    disabled: {
      true: '!text-disabled',
    },
  },
  compoundVariants: [
    {
      variant: 'soft',
      color: 'gray',
      className: 'text-utility-gray-700',
    },
    {
      variant: 'soft',
      color: 'brand',
      className: 'text-utility-brand-700',
    },
    {
      variant: 'soft',
      color: 'error',
      className: 'text-utility-error-700',
    },
    {
      variant: 'soft',
      color: 'warning',
      className: 'text-utility-warning-700',
    },
    {
      variant: 'soft',
      color: 'success',
      className: 'text-utility-success-700',
    },
    {
      variant: 'soft',
      color: 'blue',
      className: 'text-utility-blue-700',
    },
    {
      variant: 'soft',
      color: 'purple',
      className: 'text-utility-purple-700',
    },
    {
      variant: 'soft',
      color: 'fuchsia',
      className: 'text-utility-fuchsia-700',
    },
    {
      variant: 'soft',
      color: 'cyan',
      className: 'text-utility-cyan-700',
    },
    {
      variant: 'soft',
      color: 'lime',
      className: 'text-utility-lime-700',
    },
    {
      variant: 'soft',
      color: 'pink',
      className: 'text-utility-pink-700',
    },
    {
      variant: 'soft',
      color: 'violet',
      className: 'text-utility-violet-700',
    },
    {
      variant: 'soft',
      color: 'indigo',
      className: 'text-utility-indigo-700',
    },
    {
      variant: 'soft',
      color: 'rose',
      className: 'text-utility-rose-700',
    },
    {
      variant: 'clear',
      color: 'brand',
      className: 'text-utility-brand-700',
    },
    {
      variant: 'clear',
      color: 'gray',
      className: 'text-utility-gray-700',
    },
    {
      variant: 'clear',
      color: 'error',
      className: 'text-utility-error-700',
    },
    {
      variant: 'clear',
      color: 'warning',
      className: 'text-utility-warning-700',
    },
    {
      variant: 'clear',
      color: 'success',
      className: 'text-utility-success-700',
    },
    {
      variant: 'clear',
      color: 'blue',
      className: 'text-utility-blue-700',
    },
    {
      variant: 'clear',
      color: 'purple',
      className: 'text-utility-purple-700',
    },
    {
      variant: 'clear',
      color: 'fuchsia',
      className: 'text-utility-fuchsia-700',
    },
    {
      variant: 'clear',
      color: 'cyan',
      className: 'text-utility-cyan-700',
    },
    {
      variant: 'clear',
      color: 'lime',
      className: 'text-utility-lime-700',
    },
    {
      variant: 'clear',
      color: 'pink',
      className: 'text-utility-pink-700',
    },
    {
      variant: 'clear',
      color: 'violet',
      className: 'text-utility-violet-700',
    },
    {
      variant: 'clear',
      color: 'indigo',
      className: 'text-utility-indigo-700',
    },
    {
      variant: 'clear',
      color: 'rose',
      className: 'text-utility-rose-700',
    },
  ],
});

export default labelVariants;
